<template>
  <!-- <b-container class="container-content card-container translateYg text-center">
  <b-spinner  variant="primary" label="Spinning" class="text-center "></b-spinner>
  </b-container> -->
  <div></div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import { createNamespacedHelpers } from 'vuex'
import { isProduction } from '../../utils'
import { isUATEnv } from '../../helpers/network'
import ApiClient from '../../services'

const BookingStore = createNamespacedHelpers('booking')
const AuthStore = createNamespacedHelpers('auth')

@Component({
  methods: {
    ...BookingStore.mapMutations([
      'setBookingReview',
      'setPaymentBody',
      'setPaymentResult',
      'resetState',
    ]),
    ...BookingStore.mapActions(['processBooking', 'updateBooking']),
    ...AuthStore.mapActions(['refreshToken']),
  },
  computed: {
    ...BookingStore.mapState(['bookingReview', 'paymentBody', 'paymentResult']),
  },
})
export default class PaymentResult extends Vue {
  isProcessing = false
  isRetry = false
  isPrerender = ( window.__prerender && window.__prerender.prerendering ) || false

  get loadingVariant() {
    return this.bookingReview.type === 'one-time' ? `success` : `warning`
  }

  async mounted() {
    this.$store.commit('setIsLoading', true)
    this.resetState()

    if (this.isPrerender) return

    if (this.$route.query.error === "cannot_update") {
      const paymentResult = {
        errorMessage: 'cannot_update',
        status: 400,
        type: this.bookingReview.type,
        isUpdateBooking: true,
      }
      this.setPaymentResult(paymentResult)
      localStorage.paymentResult = JSON.stringify(paymentResult)
      this.$store.commit('booking/resetCurrentBookingOneTime')
      this.$store.commit('booking/resetCurrentBookingMultiPackage')
      this.$store.commit('booking/resetBookingReview')
      this.$store.commit('booking/resetBookingMultiPackage')
      this.$router.replace({ name: 'BookingConfirm' })
      return
    }

    const bookingDetailStr = window.localStorage.getItem('booking_detail')
    const paymentBodyStr = window.localStorage.getItem('payment_body')
    if (!bookingDetailStr) {
      this.$router.replace({ name: 'Home' })
      return
    }
    const bookingDetailJson = JSON.parse(bookingDetailStr)
    const paymentBodyJson = JSON.parse(paymentBodyStr)

    this.setBookingReview(bookingDetailJson)
    this.setPaymentBody(paymentBodyJson)

    if (this.$route.query.ref_no) {
      await this.handleMobileBankingReturn(this.$route.query.ref_no)
      return
    }

    if (this.bookingReview.isUpdateBooking) {
      await this.doUpdateBooking()
    } else {
      await this.doProcessBooking(false)
    }
  }

  async destroyed() {
    this.$store.commit('setIsLoading', false)
  }

  async doUpdateBooking() {
    this.isProcessing = true
    try {
      console.log('========= doUpdateBooking')
      const result = await this.updateBooking()
      if (result) {
        this.setPaymentResult({
          status: result.status,
          type: this.bookingReview.type,
          isUpdateBooking: this.bookingReview.isUpdateBooking,
        })
      }
    } catch (e) {
      console.error(e)
      const { data, status } = e.response
      if (status === 401 && !this.isRetry) {
        this.isRetry = true
        await this.refreshToken()
        await this.doUpdateBooking()
        return
      }
      this.setPaymentResult({
        errorMessage: data.error,
        status,
        type: this.bookingReview.type,
        isUpdateBooking: this.bookingReview.isUpdateBooking,
      })
    } finally {
      this.paymentResult.status === 200
        ? (localStorage.isPaid = true)
        : (localStorage.isPaid = false)
      localStorage.paymentResult = JSON.stringify(this.paymentResult)
      this.$store.commit('booking/resetCurrentBookingOneTime')
      this.$store.commit('booking/resetCurrentBookingMultiPackage')
      this.$store.commit('booking/resetBookingReview')
      this.$store.commit('booking/resetBookingMultiPackage')
      // localStorage.removeItem('useCoupon')
      // localStorage.removeItem('bodyPaySolution')
      // localStorage.removeItem('isRedirect')
      this.$router.replace({ name: 'BookingConfirm' })
      // localStorage.removeItem('isPaid')
    }
  }

  async doProcessBooking(isApproved = true) {
    console.log('this.bookingReview', localStorage.confirmPayment)
    const confirm_booking = await ApiClient.confirmBooking(JSON.parse(localStorage.confirmPayment))
    localStorage.confirmPayment = null
    // if( confirm_booking)
    console.log('confirm booking', confirm_booking)
    console.log('========== doProcessBooking')
    this.isProcessing = true
    try {
      // if (typeof this.bookingReview.coupon_body === 'object' && this.bookingReview.coupon_body) {
      //   this.bookingReview.coupon_body.booking_id = this.bookingReview.id
      //   this.bookingReview.coupon_body.used = true
      //   await ApiClient.applyCoupon(this.bookingReview.coupon_body)
      // }
      // confirm_booking = await ApiClient.confirmBooking(JSON.parse(localStorage.confirmPayment))
      // // localStorage.removeItem('confirmPayment')
      // this.isProcessing = true
      const result = await this.processBooking(isApproved)
      // console.log(result)
      if (result) {
        // if (isProduction()) {
        //   this.$gtag('event', 'conversion', {
        //     send_to: 'AW-685115829/6OegCM_e6eIBELWT2MYC',
        //     transaction_id: this.paymentBody.refno || '',
        //   })
        //   fbq('init', '1905678540813907')
        //   fbq('track', 'PageView')
        // }
        this.setPaymentResult({
          status: result.status,
          type: this.bookingReview.type,
          isUpdateBooking: this.bookingReview.isUpdateBooking,
        })
      }
    } catch (e) {
      console.log(e.response)
      const { data, status } = e.response
      console.log('eeee', e)
      if (status === 401 && !this.isRetry) {
        this.isRetry = true
        await this.refreshToken()
        await this.doProcessBooking()
        return
      }

      this.setPaymentResult({
        errorMessage: data.error,
        status,
        type: this.bookingReview.type,
        isUpdateBooking: this.bookingReview.isUpdateBooking,
      })
    } finally {
      console.log('this.paymentResult', this.paymentResult)
      this.paymentResult.status === 200
        ? (localStorage.isPaid = true)
        : (localStorage.isPaid = false)
      // console.log('finally')
      // if (isProduction() && this.paymentResult.status === 200) {
      //   this.$gtag.event('conversion', {
      //     send_to: 'AW-685115829/6OegCM_e6eIBELWT2MYC',
      //     transaction_id: this.paymentBody.refno || '',
      //   })
      //   fbq('init', '1905678540813907')
      //   fbq('track', 'PageView')
      // }
      localStorage.paymentResult = JSON.stringify(confirm_booking)
      this.$router.replace({ name: 'BookingConfirm' })
    }
  }

  async handleMobileBankingReturn(ref_no) {
  const is_update_booking = this.$route.query.is_update_booking === 'true'
    try {
      let res
      for (let i = 0; ; i++) {
        try {
          res = await ApiClient.checkPaymentStatus(ref_no)
          if (res.data.success || i >= 5) break
        } catch (e) {
          const notFound = e.response && e.response.data && e.response.data.error == 'payment_not_found'
          if (!notFound || i >= 5) throw e
        }
        await new Promise(resolve => setTimeout(resolve, 1000))
      }
      const result = res.data
      const paymentResult = {
        status: result.success ? 200 : 400,
        type: result.type,
        booking_type: result.booking_type,
        isUpdateBooking: is_update_booking,
        errorMessage: result.success ? undefined : 'payment_not_completed',
        ref_no: result.ref_no,
      }
      localStorage.isPaid = result.success
      localStorage.paymentResult = JSON.stringify(paymentResult)
      this.$router.replace({ name: 'BookingConfirm' })
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error == 'payment_not_found') {
        alert(this.$t("status.online_banking_rejected"));
        this.$router.replace(this.$route.query.currentRoute)
        return
      } 
      localStorage.isPaid = false
      localStorage.paymentResult = JSON.stringify({
        status: 400,
        errorMessage: 'payment_not_completed',
        isUpdateBooking: is_update_booking,
      })
      this.$router.replace({ name: 'BookingConfirm' })
    }
  }
}
</script>

<style lang="css">
.card-container {
  min-height: auto;
}
</style>
